import { api } from '..';

export function addMusic(data) {
  return api('UPLOAD', `/panel/files/music`, data);
}

export function addModel(data) {
  return api('UPLOAD', `/panel/files/model`, data);
}
